import { getStations, getUserID, getUser } from '@/utils/requestHandler.js'
import ListSearch from '@/components/ListSearch/ListSearch.vue'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import Notification from '@/components/Notification/Notification.vue'
import { mapMutations, mapGetters } from 'vuex'

export default {
   name: 'AllStations',
   components: {
      ListSearch,
      LoadingSpinner,
      BadRequest,
      Notification
   },
   data() {
      return {
         stationsResponse: null,
         error: null,
         loading: true,
         filterTriggered: 0,
         checked: false,
         searchIndex: 'search'
      }
   },
   async created() {
      await this.getNewUserPosition()

      this.stationsResponse = await getStations()
      if (typeof this.stationsResponse == 'string') {
         if (this.stationsResponse.includes('Request failed') || this.stationsResponse.toLowerCase().includes('error')) {
            this.error = this.stationsResponse
            console.log(this.error)
            this.loading = false
         }
      }

      this.userNameResponse = await getUserID()
      if (typeof this.userNameResponse == 'string') {
         if (this.userNameResponse.includes('Request failed') || this.userNameResponse.toLowerCase().includes('error')) {
            this.error = this.userNameResponse
            console.log(this.error)
            this.loading = false
         }
      }
      let userID = this.userNameResponse.name

      this.userResponse = await getUser(userID)
      if (typeof this.userResponse == 'string') {
         if (this.userResponse.includes('Request failed') || this.userResponse.toLowerCase().includes('error')) {
            this.error = this.userResponse
            console.log(this.error)
            this.loading = false
         }
      }
      let userName = this.userResponse
         .split(' ')
         .reverse()
         .join(' ')

      this.setNewUserName(userID)
      this.setNewUser(userName)
      this.loading = false

      console.log(this.getStateUserID)
      console.log(this.getStateUserName)
      console.log(this.getStateUserPosition)
   },
   mounted() {
      // Shows a logout message for 4sec
      if (localStorage.showLoginMessage) {
         localStorage.removeItem('showLoginMessage')
         setTimeout(() => {
            this.$refs.notification.show()
         }, 400)
         setTimeout(() => {
            this.$refs.notification.close()
         }, 4000)
      }
   },
   methods: {
      ...mapMutations(['setStateUserID', 'setStateUserName', 'setStateUserPosition']),

      //Gets the current location of the user to show it on the map
      getNewUserPosition() {
         navigator.geolocation.getCurrentPosition(this.getPosition, this.showError)
      },
      getPosition(position) {
         const latitude = parseFloat(position.coords.latitude.toFixed(8))
         const longitude = parseFloat(position.coords.longitude.toFixed(8))
         const userPosition = [longitude, latitude]
         this.setNewUserPosition(userPosition)
      },
      showError() {
         alert(
            "Couldn't access current geo location\n\nGeo location was either denied by the user or the device doesn't support it.\nPlease contact your IT-Administrator for futher help."
         )
      },
      serchByCode() {
         if (this.checked === false) {
            this.searchIndex = 'code'
            this.checked = true
            this.filterTriggered++
         } else {
            this.searchIndex = 'search'
            this.checked = false
            this.filterTriggered++
         }
      },

      //Setters for stats
      setNewUserName(userID) {
         this.setStateUserID(userID)
      },
      setNewUser(userName) {
         this.setStateUserName(userName)
      },
      setNewUserPosition(userPosition) {
         this.setStateUserPosition(userPosition)
      }
   },
   computed: {
      ...mapGetters(['getStateUserID', 'getStateUserName', 'getStateUserPosition'])
   }
}
